import { useEffect, useState } from "react";
import { Download } from "lucide-react";
import { toast } from "sonner";
import { AdminGuard } from "@/components/admin/AdminGuard";
import { errText } from "@/lib/api";
import { adminSubscribers, adminSubscribersCsv } from "@/lib/admin";

const List = () => {
  const [rows, setRows] = useState(null);
  useEffect(() => { adminSubscribers().then(setRows).catch((e) => toast.error(errText(e))); }, []);
  const exportCsv = async () => {
    const blob = await adminSubscribersCsv();
    const url = URL.createObjectURL(blob);
    const a = Object.assign(document.createElement("a"), { href: url, download: "subscribers.csv" });
    a.click();
    URL.revokeObjectURL(url);
  };
  return (
    <>
      <div className="flex flex-wrap items-end justify-between gap-6 pt-10">
        <h1 className="display text-6xl">Subscribers</h1>
        <button onClick={exportCsv} className="btn btn-outline" data-testid="admin-export-csv"><Download size={16} /> Export CSV</button>
      </div>
      <p className="label mt-8 text-ink/50" data-testid="admin-subscriber-count">{rows ? `${rows.length} subscribers` : "Loading…"}</p>
      <table className="mt-4 w-full text-left text-sm" data-testid="admin-subscribers-table">
        <thead><tr className="label border-b border-ink/15 text-ink/50"><th className="py-3">Email</th><th>Source</th><th>Joined</th></tr></thead>
        <tbody>{rows?.map((r) => (
          <tr key={r.email} className="border-b border-ink/10"><td className="py-3">{r.email}</td><td className="font-mono text-xs">{r.source}</td><td className="font-mono text-xs">{new Date(r.created_at).toLocaleString("en-CA")}</td></tr>
        ))}</tbody>
      </table>
    </>
  );
};

export default function AdminSubscribers() {
  return <AdminGuard><List /></AdminGuard>;
}
